import React from 'react';
import styled from 'styled-components';
import { decorativeElements } from '../../assets/graphics';
import { colors } from '../../styles/colors';

const DecorativeWrapper = styled.div`
  position: absolute;
  pointer-events: none;
  z-index: ${props => props.zIndex || 1};
  ${props => props.customStyles};
  
  svg {
    width: ${props => props.width || '100px'};
    height: ${props => props.height || '100px'};
    fill: ${props => props.fill || colors.accent};
    opacity: ${props => props.opacity || 0.1};
    transform: ${props => props.rotate ? `rotate(${props.rotate}deg)` : 'none'};
  }
  
  @media (max-width: 768px) {
    svg {
      width: ${props => props.mobileWidth || props.width || '60px'};
      height: ${props => props.mobileHeight || props.height || '60px'};
    }
  }
`;

const DecorativeElement = ({
  type = 'leafPattern',
  position = { top: 0, left: 0 },
  width,
  height,
  mobileWidth,
  mobileHeight,
  fill,
  opacity,
  rotate,
  zIndex,
  customStyles = ''
}) => {
  return (
    <DecorativeWrapper
      style={position}
      width={width}
      height={height}
      mobileWidth={mobileWidth}
      mobileHeight={mobileHeight}
      fill={fill}
      opacity={opacity}
      rotate={rotate}
      zIndex={zIndex}
      customStyles={customStyles}
    >
      <img src={decorativeElements[type]} alt="" aria-hidden="true" />
    </DecorativeWrapper>
  );
};

export default DecorativeElement; 